import { jeepRallyApi } from "../api";

const baseUrl = "/api/v1/categories";

export const getAllCategories = (params = {}) => {
  const query = {};
  if (params.status === "active" || params.status === "inactive") {
    query.status = params.status;
  }

  return jeepRallyApi.get(baseUrl, { params: query });
};

export const getCategoriesWithConsentForms = () => {
  return jeepRallyApi.get(`${baseUrl}/consent-forms`);
};

export const getCategoryById = (id) => {
  return jeepRallyApi.get(`${baseUrl}/${id}`);
};

export const createCategory = (formData) => {
  return jeepRallyApi.post(baseUrl, formData);
};

export const updateCategory = (id, formData) => {
  return jeepRallyApi.patch(`${baseUrl}/${id}`, formData);
};

export const uploadCategoryConsentDocument = (id, file) => {
  const formData = new FormData();
  formData.append("consent_document", file);
  return jeepRallyApi.post(`${baseUrl}/${id}/consent`, formData);
};

export const deleteCategory = (id) => {
  return jeepRallyApi.delete(`${baseUrl}/${id}`);
};
